import React from 'react'
import { RegistrationListItem } from './RegistrationListItem'
import Slider from 'react-slick'
import { AddValidatorFunc } from '../../hooks/validators'
import { useAppSelector } from '../../hooks'

const SliderArrow = (props: {
  className?: string
  style?: React.CSSProperties
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}) => {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    />
  )
}

const RegistrationList = (props: {
  isEditable: boolean
  addValidator?: AddValidatorFunc
}) => {
  const { isEditable, addValidator } = props
  const { list: registrations } = useAppSelector(
    (state) => state.registrations,
  )
  const slickSettings = {
    accessibility: true,
    dots: true,
    infinite: registrations.length > 3,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    nextArrow: <SliderArrow />,
    prevArrow: <SliderArrow />,
    arrows: true,
    vertical: false,
    responsive: [
      {
        breakpoint: 1224,
        settings: {
          slidesToShow: registrations.length,
          slidesToScroll: registrations.length,
          infinite: false,
          dots: false,
          vertical: true,
          arrows: false,
          adaptiveHeight: false,
        },
      },
    ],
  }
  const cards = registrations
    .slice()
    .sort((a, b) => a.priority - b.priority)
    .map((registration) => (
      <RegistrationListItem
        key={`registration-${registration.event.event_id}`}
        registration={registration}
        editable={isEditable}
        addValidator={addValidator}
      />
    ))

  return (
    <Slider {...slickSettings} className='mb-3'>
      {cards}
    </Slider>
  )

}

export default RegistrationList
